export default "__VITE_ASSET__DmfrRt5J__"